import { divisionsEndpoints } from "@omega/omp-api";
import type { RequestConfig } from "@app/config/axios/http";
import { ompTransport } from "@src/api/ompTransport";
import type { PaginationReturns } from "@src/api/types/PaginationReturns";
import type { ApiDivision, ApiDivisionFilter, ApiDivisionTypeItem } from "./types";

/**
 * Транспортный слой OMP — подразделения.
 * Контракт и wire-формат — из пакета `@omega/omp-api`.
 */
export const divisionApi = {
    /**
     * Загружает подразделения по фильтру с пагинацией.
     */
    load: async (
        params: {
            flt?: ApiDivisionFilter;
            offset?: number;
            limit?: number;
        },
        config?: RequestConfig,
    ): Promise<PaginationReturns<ApiDivision>> => {
        const { flt, offset, limit } = params;
        return divisionsEndpoints.loadByFilter.call(
            ompTransport,
            {
                ...flt,
                Pagination: {
                    Offset: offset,
                    Limit: limit,
                },
            },
            config,
        );
    },

    /**
     * Загружает коды и наименования типов подразделений.
     * Запрос уходит в endpoint `divisions/storeDivisions.loadDivisionTypes`.
     */
    loadDivisionTypes: async (config?: RequestConfig): Promise<ApiDivisionTypeItem[]> => {
        return divisionsEndpoints.loadDivisionTypes.call(ompTransport, {}, config);
    },
} as const;
